module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-runtime/core-js/array/from.js
// module id = 424
// module chunks = 0